<template>
  <div>
    <v-dialog v-model="dialog" max-width="900px">
      <v-card>
        <v-card-title class="blue darken-3 white--text">
          <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <div>
              <v-row no-gutters class="xcard mb-8" style="background:#EBEBEB">
                <v-col cols="12" sm="6" md="5">
                  <v-select
                    v-model="sucursal.nit_id"
                    :items="nits"
                    item-text="nro"
                    return-object
                    label="* Nit:"
                    outlined
                    hide-details
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="7">
                  <v-text-field
                    v-model.trim="sucursal.direccion"
                    label="* Direccion"
                    class="pl-2"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field
                    type="number"
                    v-model.number="sucursal.numero_sucursal"
                    label="Numero sucursal"
                    class="pr-2 pt-2"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model.trim="sucursal.telefono"
                    label="* Telefono"
                    class="pr-2 pt-2"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model.trim="sucursal.ciudad"
                    label="Ciudad"
                    class="pt-2 pr-2"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model.trim="sucursal.municipio"
                    label="* Municipio"
                    class="pt-2"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-checkbox
                    v-model="sucursal.is_directo"
                    label="Factura directa"
                    class="pt-2"
                    outlined
                    dense
                  ></v-checkbox>
                </v-col>
                <!-- <v-col cols="12" sm="6" md="5">
                  <v-text-field
                    v-show="iselectronica"
                    v-model.trim="sucursal.nombre"
                    label="* Nombre"
                    class="pt-2 pr-2"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="7">
                  <v-text-field
                    v-show="iselectronica"
                    v-model.trim="sucursal.descripcion"
                    label="* Descripcion"
                    class="pt-2"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col> -->
              </v-row>
            </div>
          </v-container>
          <p class="text-center red--text">{{ msg }}</p>
          <v-progress-linear indeterminate v-if="loading" />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-3" class="white--text" @click="dialog = !dialog">
            Cerrar
          </v-btn>
          <v-btn color="green darken-3" class="white--text" :disabled="loading || exitoso" @click="save">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      loading: false,
      exitoso: false,
      msg: '',
      iselectronica: false,
      sucursal: {
        id: null,
        nit_id: null,
        numero_sucursal: 0,
        direccion: null,
        telefono: null,
        ciudad: null,
        municipio: null,
        nombre: null,
        descripcion: null,
        is_directo: null,
      },
      nits: [],
    }),

    computed: {
      formTitle() {
        return this.sucursal.id ? 'Editar Sucursal' : 'Registrar nueva Sucursal';
      },
    },
    watch: {
      'sucursal.nit_id': function() {
        this.iselectronica = false;
        if (!this.sucursal.nit_id) return;
        let n = this.nits.find((nt) => nt.id == this.sucursal.nit_id.id);
        //window.console.log('._.', n, this.sucursal.nit_id.id);
        if (!n) return;
        if ((n.tipo_facturacion + '').includes('ELECTR')) {
          this.iselectronica = true;
        }
      },
    },

    methods: {
      openmodal(item) {
        this.dialog = true;
        this.loading = false;
        this.exitoso = false;
        this.iselectronica = false;
        this.sucursal.id = null;
        this.sucursal.nit_id = null;
        this.sucursal.numero_sucursal = 0;
        this.sucursal.is_directo = null;
        this.sucursal.direccion = null;
        this.sucursal.telefono = null;
        this.sucursal.ciudad = null;
        this.sucursal.municipio = null;
        this.sucursal.nombre = null;
        this.sucursal.descripcion = null;
        this.msg = '';
        if (item) {
          this.getitem(item);
          //this.getitemfact(item);
        }
      },
      getNits() {
        let vue = this;
        let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/nits`;
        xaxios.get(url).then((data) => {
          let datas = data.data.data;
          vue.nits = datas;
        });
      },
      vallength(str, min = 0, max = 255) {
        if (!str) return true;
        if (str.length < min) return true;
        if (str.length > max) return true;
        return false;
      },
      getitem(item) {
        //item.id = 18;
        const vue = this;
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        let urlc = `${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${item.id}`;
        let raw = JSON.stringify({ unidad_negocio_id: unidad });
        this.loading = true;
        xaxios.get(urlc, raw).then((data) => {
          //window.console.log('>', data.data);
          let su = data.data;
          vue.sucursal.id = su.id;
          vue.sucursal.nit_id = vue.nits.find((n) => n.nro == su.nit);
          vue.sucursal.numero_sucursal = su.numero_sucursal;
          vue.sucursal.telefono = su.telefono;
          vue.sucursal.direccion = su.direccion;
          vue.sucursal.ciudad = su.ciudad;
          vue.sucursal.municipio = su.municipio;
          vue.sucursal.is_directo = su.is_directo;
          vue.loading = false;
        });
      },
      async save() {
        this.msg = '';
        if (this.vallength(this.sucursal.municipio, 3, 255))
          this.msg = 'El municipio debe estar entre 3 y 255 caracteres.';
        if (!this.sucursal.nit_id) this.msg = 'Seleccione un nit.';
        if (this.vallength(this.sucursal.direccion, 3, 255))
          this.msg = 'La direccion debe estar entre 3 y 255 caracteres.';
        if (this.vallength(this.sucursal.telefono, 3, 20)) this.msg = 'El telefono debe estar entre 3 y 20 caracteres.';
        if (this.msg) return;
        this.loading = true;

        let data = {
          nit_id: this.sucursal.nit_id.id,
          numero_sucursal: this.sucursal.numero_sucursal,
          is_directo: this.sucursal.is_directo,
          direccion: this.sucursal.direccion,
          telefono: this.sucursal.telefono,
          ciudad: this.sucursal.ciudad,
          municipio: this.sucursal.municipio,
          nombre: this.sucursal.nombre,
          descripcion: this.sucursal.descripcion,
        };

        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales`;
        let metodo;
        if (this.sucursal.id) {
          data.id = this.sucursal.id;
          metodo = 'put';
        } else {
          metodo = 'post';
        }
        window.console.log(data);
        if (this.iselectronica) {
          // this.saveToFacturacion(data, metodo);
          this.updateSucursalFacturacion(data, metodo);
        }

        xaxios.request({
          method: metodo,
          url: url,
          data: data,
        })
          .then(({ data }) => {
            window.console.log(data, vue);
            vue.msg = data.data;
            vue.loading = false;
            vue.exitoso = true;
            vue.$emit('newregsucursal');
            setTimeout(() => {
              vue.dialog = false;
            }, 800);
          })
          .catch((e) => {
            window.console.log(e.response.data);
            try {
              vue.msg = e.response.data.errors[0];
            } catch (e) {
              window.console.log(e);
            }
            vue.loading = false;
            if (!vue.msg) {
              vue.$emit('newregsucursal', vue.sucursal);

              setTimeout(() => {
                vue.dialog = false;
              }, 800);
            }
          });
      },
      updateSucursalFacturacion(s, metodo) {
        let dx = '';
        if (metodo == 'put') dx = '/codigo';
        let config = {
          method: metodo,
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/sucursales${dx}`,
          headers: {
            apikey: this.$store.getters.getApiKey,
          },
          data: {
            codigoSucursal: s.numero_sucursal,
            descripcion: s.direccion,
            direccion: s.direccion,
            estado: 1,
            municipio: s.municipio,
            nombre: s.ciudad,
            telefono: s.telefono,
          },
        };
        xaxios.request(config)
          .then(({ data }) => {
            window.console.log('updateSucursalFacturacion:', data);
          })
          .catch((e) => {
            window.console.log(e);
          });
      },
      saveToFacturacion(data, metodo) {
        let suc = {
          codigoSucursal: data.numero_sucursal,
          is_directo: data.is_directo,
          descripcion: data.descripcion,
          direccion: data.direccion,
          estado: 1,
          id: data.id,
          municipio: data.municipio,
          nombre: data.nombre,
          telefono: data.telefono,
        };
        const url = `${process.env.VUE_APP_FACT_REST}/facturacion/sucursales`;
        xaxios.request({
          method: metodo,
          url: url,
          data: suc,
          headers: {
            apikey: this.$store.getters.getApiKey,
          },
        })
          .then((response) => {
            window.console.log(response);
          })
          .catch((e) => {
            window.console.log(e.response.data);
          });
      },
    },
    mounted() {
      this.getNits();
    },
  };
</script>
